import { render, staticRenderFns } from "./Fechamentos.vue?vue&type=template&id=1dedb005"
import script from "./Fechamentos.vue?vue&type=script&lang=js"
export * from "./Fechamentos.vue?vue&type=script&lang=js"
import style0 from "./Fechamentos.vue?vue&type=style&index=0&id=1dedb005&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports